/** Stack of Android hardware-back handlers. Return true if the press was consumed. */
const handlers = [];

export const registerAndroidBackHandler = (handler) => {
  if (typeof handler !== 'function') return () => {};
  handlers.push(handler);
  return () => {
    const i = handlers.lastIndexOf(handler);
    if (i >= 0) handlers.splice(i, 1);
  };
};

/**
 * Send the app to the background (Android home). No-op on web / if the plugin
 * is unavailable. Use where "back" has nowhere sensible to go in-app — e.g. the
 * live-trip screen, where routing away just bounces straight back and reloads
 * the map.
 */
export const minimizeApp = () => {
  import('@capacitor/app')
    .then(({ App }) => App.minimizeApp?.())
    .catch(() => {});
};

/** Called from MainActivity via evaluateJavascript. */
export const initAndroidBackBridge = () => {
  if (typeof window === 'undefined') return;
  window.__mtHandleAndroidBack = () => {
    for (let i = handlers.length - 1; i >= 0; i -= 1) {
      try {
        if (handlers[i]()) return true;
      } catch (e) {
        console.warn('android back handler:', e);
      }
    }
    return false;
  };
};
